module.exports = __webpack_public_path__ + "static/apple-icon-76x76-a46bbc1354a53efaeea9cd30b1d5f5b6.png";